import { Banner } from "./common";
import { Media } from "./media";
export interface Account {
  id: string;
  name: string;
  description?: string | null;
  companyUrl?: string | null;
  collectionSettings: {
    banner: Banner | null,
    template: string | null,
    live: boolean,
    viewerType: 'MASONRY' | 'BENTO_GRID' | 'CAROUSEL' | 'DEAL_ROOM',
    assetViewer: 'LIST_VIEWER' | 'GALLERY_VIEWER' | 'IMMERSE_VIEWER',
  },
  contentSettings: {
    expireContent: boolean;
    createdDate: Date | null;
    dealInsightsEnabled: boolean;
  },
  dealRoomSettings : {
      banner: Banner | null,
      template: string | null,
      live: boolean,
      viewerType: 'MASONRY' | 'BENTO_GRID' | 'CAROUSEL' | 'DEAL_ROOM',
      assetViewer: 'LIST_VIEWER' | 'GALLERY_VIEWER' | 'IMMERSE_VIEWER',
    },
  shareSettings: {
    download: true,
    reshare: false,
    gated: true,
    overrideGatingFormTemplateUrl: null,
    downloadEditable: true,
    validateEmailDomain: true
  },
  librarySettings: {
    banner: Banner | null,
    message: string | null,
    primaryColor: string | null,
    buttonTextColor: string | null,
    fontFamily: string | null,
    shareText: string | null,
    assetViewRegular: {
      backgroundColor: string | null,
      textColor: string | null,
      subTextColor: string | null,
      separatorColor: string | null,
      disabledColor: string | null
    },
    assetViewActive: {
      backgroundColor: string | null,
      textColor: string | null,
      subTextColor: string | null,
      separatorColor: string | null,
      disabledColor: string | null
    },
    passwordText: {
      heading: string | null,
      descriptionText: string | null,
      buttonText: string | null,
      placeHolder: string | null
    },
    gatingText: {
      heading: string | null,
      descriptionText: string | null,
      buttonText: string | null,
      placeHolder: string | null
    },
    ndaText: {
      heading: string | null,
      descriptionText: string | null,
      buttonText: string | null,
      placeHolder: string | null
    },
    reshareEmail: string | null,
    otpText: {
      heading: string | null,
      descriptionText: string | null,
      buttonText: string | null,
      placeHolder: string | null
    },
    assetViewer: 'LIST_VIEWER' | 'GALLERY_VIEWER' | 'IMMERSE_VIEWER',
  },
  logo: Media | null,
  banner: Banner | null,
  favIcon: Media | null,
  background: Media | null,
  createdDate: Date,
  modifiedDate: Date,
  hubEnabled: boolean,
  hubAdvancedEnabled: boolean,
  reportingEnabled: boolean,
  collectionSectionEnabled: boolean,
  collectionOverlayEnabled: boolean,
  microsoftEditAccessEnabled: boolean,
  allocadiaIntegrationEnabled: boolean,
  liveCollectionEnabled: boolean,
  recommendationEnabled: boolean,
  engageEnabled: boolean,
  manageRoles: boolean,
  viewerUpgradeEnabled: boolean,
  referralEnabled: boolean,
  trialBanner: boolean,
  dealInsightsEnabled: boolean,
  privacyPolicy: {
    url: string,
    consentType: 'MANDATORY' | 'OPTIONAL',
    customPrivacyPolicy: boolean,
    enabledGeoLocation: boolean,
    policyModifiedDate: Date | null,
    overridePrivacyPolicyUrl: string | null
  },
  subscription: {
    type: 'PAID' | 'TRIAL',
    noOfDays: number,
    invitationLimit: number,
    changedDate: Date,
    contractTerm: string | null,
    endDate: Date | null,
    subscriptionPlan: {
      id: string,
      name: string,
      product: 'paperflite' | 'cleverstory',
      key: string,
      storageLimit: number,
      datasourceFileLimit: number,
      hub: {
        access: boolean,
        customHub: number
      },
      contentMap: {
        access: boolean,
      },
      createAsset: {
        access: boolean,
      },
      collection: {
        access: boolean,
        collaborate: boolean,
        viewerTypeList: string[],
        assetViewerList: [],
      },
      report: {
        access: boolean
      },
      share: {
        access: boolean
      },
      nativeEditor: {
        access: boolean
      },
      engage: {
        access: boolean
      },
      dealInsights: {
        access: boolean
      },
      default: boolean
    },
    suspended: boolean
  },
  theme: any | null,
  globalContactEnabled: boolean,
  ssoLoginMandatory: boolean,
  contentModerators: boolean,
  seekEnabled: boolean,
  socialShareEnabled: boolean,
  subtitleEnabled: boolean,
  billingEnabled: boolean,
  starterRoleEnabled: boolean,
  paperfliteEmailServerEnabled: boolean,
  fliteviewSeekEnabled: boolean,
  viewerLanguage: string | null,
  maintenance: any | null,
  cleverstoryIntegration: boolean
}
export interface UpdateAccountRequest {
  name?: string;
  companyUrl?: string | null;
  favIcon?: Media | null;
  logo?: Media | null;

  collectionSettings?: {
    banner: Banner | null,
    template: string | null,
    live: boolean,
    viewerType: 'MASONRY' | 'BENTO_GRID' | 'CAROUSEL' | 'DEAL_ROOM',
    assetViewer: 'LIST_VIEWER' | 'GALLERY_VIEWER' | 'IMMERSE_VIEWER',
  },
  dealRoomSettings?: {
    banner: Banner | null,
    template: string | null,
    live: boolean,
    viewerType: 'MASONRY' | 'BENTO_GRID' | 'CAROUSEL' | 'DEAL_ROOM',
    assetViewer: 'LIST_VIEWER' | 'GALLERY_VIEWER' | 'IMMERSE_VIEWER',
  },
  shareSettings?: {
    download: true,
    reshare: false,
    gated: true,
    overrideGatingFormTemplateUrl: null,
    downloadEditable: true,
    validateEmailDomain: true
  },
  contentSettings?: {
    expireContent: boolean;
    createdDate?: Date | null;
    dealInsightsEnabled?: boolean;
  },

  librarySettings?: {
    banner?: Banner | null;
    message?: string | null;
    primaryColor?: string | null;
    buttonTextColor?: string | null;
    fontFamily?: string | null;
    shareText?: string | null;

    assetViewRegular?: {
      backgroundColor?: string | null;
      textColor?: string | null;
      subTextColor?: string | null;
      separatorColor?: string | null;
      disabledColor?: string | null;
    };

    assetViewActive?: {
      backgroundColor?: string | null;
      textColor?: string | null;
      subTextColor?: string | null;
      separatorColor?: string | null;
      disabledColor?: string | null;
    };

    passwordText?: {
      heading?: string | null;
      descriptionText?: string | null;
      buttonText?: string | null;
      placeHolder?: string | null;
    };

    gatingText?: {
      heading?: string | null;
      descriptionText?: string | null;
      buttonText?: string | null;
      placeHolder?: string | null;
    };

    ndaText?: {
      heading?: string | null;
      descriptionText?: string | null;
      buttonText?: string | null;
      placeHolder?: string | null;
    };

    otpText?: {
      heading?: string | null;
      descriptionText?: string | null;
      buttonText?: string | null;
      placeHolder?: string | null;
    };

    reshareEmail?: string | null;
    assetViewer?: 'LIST_VIEWER' | 'GALLERY_VIEWER' | 'IMMERSE_VIEWER';
  };
}

export enum SubscriptionPlan {
  STARTER = "STARTER",
  LEGACY = "LEGACY",
  PROFESSIONAL = "PROFESSIONAL",
  ENTERPRISE = "ENTERPRISE",
  ADVANCED = "ADVANCED"
}
